module.exports = __webpack_public_path__ + "static/media/vinuni.815a75de.svg";